import { useIntl } from "react-intl";
import { Reservation } from "@/components/pages/account/_helpers/useFetchUserReservations";
import { CtaButton } from "@/components/common/ctaButton/CtaButton";
import { RideType } from "@/interfaces/searchBlock";
import styles from "./ResumeBlock.module.scss";

type ResumeBlockProps = {
  reservation: Reservation;
};

const hostUrl = process.env.NEXT_PUBLIC_HOST_URL ?? "";
const quoteConfirmationPath = "/reservation/assurance-options?idReservation=";

export const ResumeBlock = ({ reservation }: ResumeBlockProps) => {
  const intl = useIntl();

  const onClickCta = (id: string) => {
    window.location.href = `${hostUrl}${quoteConfirmationPath}${id}`;
  };

  const rideType: RideType =
    reservation.travel.startAgency.id === reservation.travel.endAgency.id
      ? RideType.ROUND_TRIP
      : RideType.ONE_WAY;

  return (
    <div className={styles.content}>
      <div className={styles.kmPlan}>
        <div className={styles.kmPlan}>
          {rideType === RideType.ROUND_TRIP &&
            `${reservation.travel.kilometer} km`}
          {rideType === RideType.ONE_WAY &&
            `Km ${intl.formatMessage({ id: "unlimited" })}`}
        </div>
      </div>
      <div className={styles.insurance}>
        {reservation.insuranceChoice?.title}
      </div>
      {reservation.optionsChoices.length >= 1 && (
        <div className={styles.options}>
          <div className={styles.title}>
            <div className={styles.label}>
              {intl.formatMessage({ id: "myOptions" })}
            </div>
            {/* <div className={styles.optionChange}>
              {intl.formatMessage({ id: "changeMyOrder" })}
            </div> */}
          </div>
          {reservation.optionsChoices.map((option, index) => (
            <div className={styles.option} key={index}>
              {option.title}
            </div>
          ))}
        </div>
      )}
      <div className={styles.paymentInfos}>
        <div>
          <div className={styles.price}>
            <span className={styles.label}>
              {intl.formatMessage({ id: "total" })}
            </span>
            {reservation.price} €
          </div>
          <div className={styles.status}></div>
        </div>
        {!reservation.bookingId && (
          <div className={styles.completeButton}>
            <CtaButton
              label={intl.formatMessage({
                id: "userQuoteConfirmation",
              })}
              onClick={() => onClickCta(reservation.id)}
            />
          </div>
        )}
      </div>
    </div>
  );
};
